<template>
	<module class="module-config" :drag="false" gap="10">
		<module-col v-for="(item, i) in dataList" :key="i" :title="`图表${i + 1}`">
			<c-form ref="form" vertical unit-width="100%">
				<c-form-item label="图表名称" required>
					<c-input v-model="item.name" name="name"></c-input>
				</c-form-item>
				<c-form-item label="数据源" required>
					<c-select v-model="item.source" name="source" :options="chartsDataSource" :clear="false" @change="sourceHandle(item, i)"></c-select>
				</c-form-item>
				<c-form-item label="图表类型" required>
					<ul class="chart-type flex">
						<li v-for="(chart, i) in chartType" :key="i" class="flex-column flex-center" :class="{'z-crt': item.type == chart.value}" @click="chartTypeHandle(item, chart)">
							<i class="icon tf">{{chart.icon}}</i>
							<p>{{chart.name}}</p>
						</li>
					</ul>
				</c-form-item>
				<div class="flex" style="width: 100%; gap: 10px">
					<c-form-item class="flex-grow" label="维度" required style="width: 0;">
						<c-select v-model="item.dimension" name="dimension" :options="item.dimensionOptions" :clear="false"></c-select>
					</c-form-item>
					<c-form-item v-show="dimensionDataType[i] == 3" label="汇总方式" style="width: 120px;">
						<c-select v-model="item.format" :options="formatOptions" :clear="false"></c-select>
					</c-form-item>
				</div>
				<div class="flex" style="width: 100%; gap: 10px">
					<c-form-item class="flex-grow" :label="item.type == 4 ? '指标项 (左)' : '指标项'" required style="width: 0;">
						<c-select v-model="item.quota1" name="quota1" :options="item.quotaOptions" :clear="false"></c-select>
					</c-form-item>
					<c-form-item label="计算方式" style="width: 120px;">
						<c-select v-model="item.computed1" :options="quotaComputedOptions[quotaDataType[i][0]]" :clear="false"></c-select>
					</c-form-item>
				</div>
				<div v-show="item.type == 4" class="flex" style="width: 100%; gap: 10px">
					<c-form-item class="flex-grow" label="指标项 (右)" required style="width: 0;">
						<c-select v-model="item.quota2" name="quota2" :options="item.quotaOptions" :clear="false"></c-select>
					</c-form-item>
					<c-form-item label="计算方式" style="width: 120px;">
						<c-select v-model="item.computed2" :options="quotaComputedOptions[quotaDataType[i][1]]" :clear="false"></c-select>
					</c-form-item>
				</div>
				<c-form-item label="显示数据条数" required>
					<c-input v-model="item.total" name="total" type="stepper" range="1,30" step-controls="side" :clear="false"></c-input>
				</c-form-item>
				<c-form-item label="刷新间隔时间" required>
					<c-select v-model="item.refresh" name="refresh" :options="refreshTimeOptions" :clear="false"></c-select>
				</c-form-item>
				<c-form-item label="数据过滤">
					<data-filter ref="dataFilter"></data-filter>
				</c-form-item>
			</c-form>
		</module-col>
	</module>
</template>

<script>
	import dataFilter from '@/components/view/data_filter.vue'
	import {getStore, mapStore} from '@deanwu/vue-component-library'

	export default {
		components: {
			dataFilter
		},

		data() {
			return {
				...getStore(this),
				dataList: new Array(2).fill('').map(() => {
					return {
						name: '',
						source: '',
						type: '1',
						dimensionOptions: [],
						dimension: '',
						format: 'YYYY-MM',
						quotaOptions: [],
						quota1: '',
						quota2: '',
						computed1: '',
						computed2: '',
						total: 5,
						refresh: 300
					};
				}),
				chartType: [{
					name: '折线图',
					value: 1,
					icon: '\ue633'
				}, {
					name: '柱状图',
					value: 2,
					icon: '\ue632'
				}, {
					name: '双轴图',
					value: 4,
					icon: '\ue7fe'
				}, {
					name: '饼图',
					value: 3,
					icon: '\ueb95'
				}],
				formatOptions: [{
					name: '月-日',
					value: 'MM-DD'
				}, {
					name: '年-月-日',
					value: 'YYYY-MM-DD'
				},{
                    name: '年-月',
                    value: 'YYYY-MM'
                }]
			}
		},

		computed: {
			...mapStore(['chartsDataSource', 'quotaComputedOptions', 'refreshTimeOptions']),

			dimensionDataType() {
				return this.dataList.map(item => {
					let field = item.dimensionOptions.find(field => field.value == item.dimension);
					return field ? field.type : 0;
				});
			},

			quotaDataType() {
				return this.dataList.map(item => {
					let field1 = item.quotaOptions.find(field => field.value == item.quota1);
					let field2 = item.quotaOptions.find(field => field.value == item.quota2);
					return [field1 ? field1.type : 0, field2 ? field2.type : 0];
				});
			}
		},
		
		watch: {
			chartsDataSource() {
				this.init();
			}
		},

		mounted() {
			this.store.getDataSource('charts');
		},

		methods: {
			init() {
				this.chartsDataSource.length && this.dataList.forEach((item, index) => {
					if (!item.source) {
						item.source = this.chartsDataSource[0].value;
					}
					if (!item.dimensionOptions.length) {
						this.getDimension(item);
					}
					if (!item.quotaOptions.length) {
						this.getQuota(item);
					}
					this.$refs.dataFilter[index].set(item.source, item.filter || []);
				});
			},

			sourceHandle(item, index) {
				this.$refs.dataFilter[index].set(item.source, []);
				this.updateOptions(item);
			},

			chartTypeHandle(item, chart) {
				item.type = chart.value;
				this.updateOptions(item);
			},

			updateOptions(item) {
				this.getDimension(item);
				this.getQuota(item);
			},

			getDimension(item) {
				this.store.getDimension(1, item.type, item.source, data => {
					item.dimensionOptions = data;
					this.$nextTick(() => {
						if (!item.dimension) {
							item.dimension = data[0].value;
						}
					})
				});
			},

			getQuota(item) {
				this.store.getQuota(1, item.type, item.source, data => {
					item.quotaOptions = data;
					this.$nextTick(() => {
						if (!item.quota1) {
							item.quota1 = data[0].value;
						}
						if (!item.quota2) {
							item.quota2 = data[1].value;
						}
					})
				});
			},

			setConfig(config) {
				if (config) {
					config.data.forEach((item, index) => {
						this.dataList[index] = Object.assign(this.dataList[index], item);
					});
				}
				this.dataList.forEach((item, index) => {
					this.$watch(() => item.source, (val, old) => {
						let valData = this.chartsDataSource.find(opt => opt.value == val);
						let oldData = this.chartsDataSource.find(opt => opt.value == old);
						if (!item.name.trim() || (oldData && item.name.trim() == oldData.name)) {
							item.name = valData.name;
						}
					});

					[0, 1].forEach(quotaIndex => {
						let key = `computed${quotaIndex + 1}`;
						this.$watch(() => item[key], (val, old) => {
							if (!val) {
								this.$nextTick(() => {
									let oldOpt = this.quotaComputedOptions[this.quotaDataType[index][quotaIndex]].find(item => item.value == old);
									item[key] = (oldOpt || this.quotaComputedOptions[this.quotaDataType[index][quotaIndex]][0]).value;
								});
							}
						}, {
							immediate: true
						});
					});
				});
				this.init();
			},

			getConfig() {
				return new Promise(resolve => {
					Promise.all(this.$refs.form.map($form => {
						return new Promise(resolve => {
							$form.validate({
								rule: {
									name: '请填写指标名称',
									source: '请选择数据源',
									dimension: '请选择维度',
									quota1: '请选择指标项',
									quota2: [{
										type: 'empty',
										message: '请选择指标项',
										skip: (val, data) => {
											return data.type != 4;
										}
									}],
									total: '请填写显示数据条数'
								},
								success: () => {
									resolve(true);
								},
								fail: () => {
									resolve(false);
								}
							});
						})
					})).then(data => {
						if (data.findIndex(item => item === false) == -1) {
							resolve({
								type: 1,
								data: this.dataList.map((item, index) => {
									item.filter = this.$refs.dataFilter[index].get();
									return item;
								})
							});
						} else {
							resolve(false);
						}
					})
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.chart-type {
		gap: 10px;

		li {
			gap: 8px;
			box-sizing: border-box;
			width: 60px;
			height: 60px;
			border: 1px solid #F5F5F5;
			border-radius: 6px;
			font-size: 12px;
			color: #333;
			background: #F5F5F5;
			cursor: pointer;

			&.z-crt {
				border-color: var(--color-main);
				color: var(--color-main);
			}

			&:hover {
				color: var(--color-main);
			}

			.icon {
				font-size: 24px;
			}
		}
	}
</style>